import './RadioButton.scss'

interface IRadioButton {
    label: string;
    checked?: boolean;
    name: string;
    value: string;
    onChange: (e: any) => void;
    disabled?: boolean;
}

const RadioButton: React.FC<IRadioButton> = (props) => {
    return (
        <div className="custom_radio_button">
            <label className="container">{props.label}
                <input
                    type="radio"
                    // className="form-control"
                    name={props.name}
                    checked={props.checked}
                    onChange={e => props.onChange(e.target.value)}
                    value={props.value}
                    disabled={props.disabled ? props.disabled : false}
                />
                <span className="checkmark"></span>
            </label>
        </div>
    )
}

export default RadioButton;